"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPlacementSlipGeneration = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_placement_slip_tpa_map_entity_1 = require("./opportunity-placement-slip-tpa-map.entity");
const opportunity_placement_slip_insurer_map_entity_1 = require("./opportunity-placement-slip-insurer-map.entity");
const opportunity_placement_slip_sharing_detail_entity_1 = require("./opportunity-placement-slip-sharing-detail.entity");
const opportunity_placement_slip_cd_detail_entity_1 = require("./opportunity-placement-slip-cd-detail.entity");
const opportunity_placement_slip_cover_detail_entity_1 = require("./opportunity-placement-slip-cover-detail.entity");
const look_up_entity_1 = require("./look-up.entity");
const opportunity_placement_slip_installment_detail_entity_1 = require("./opportunity-placement-slip-installment-detail.entity");
const placement_slip_document_map_entity_1 = require("./placement-slip-document-map.entity");
let OpportunityPlacementSlipGeneration = class OpportunityPlacementSlipGeneration {
    constructor(opportunityActivityId, policyFromDate, policyToDate, sumInsured, basicPremium, isPremiumInstallmentBased, fee, isFeeInInstallment, terrorismCommissionPercentage, serviceTaxPercentage, serviceTaxAmount, other, totalPremium, leadInsurerId, isLeadInsurerPayCommission, placementSlipDate, maxAgeOfDependents, brokeragePercentage, policyPlacedTypeLid, remarks, statusLid, createdBy, updatedBy) {
        this.opportunityActivityId = opportunityActivityId;
        this.policyFromDate = policyFromDate;
        this.policyToDate = policyToDate;
        this.sumInsured = sumInsured;
        this.basicPremium = basicPremium;
        this.isPremiumInstallmentBased = isPremiumInstallmentBased;
        this.fee = fee;
        this.isFeeInInstallment = isFeeInInstallment;
        this.terrorismCommissionPercentage = terrorismCommissionPercentage;
        this.serviceTaxPercentage = serviceTaxPercentage;
        this.serviceTaxAmount = serviceTaxAmount;
        this.other = other ?? null;
        this.totalPremium = totalPremium;
        this.leadInsurerId = leadInsurerId;
        this.isLeadInsurerPayCommission = isLeadInsurerPayCommission;
        this.placementSlipDate = placementSlipDate;
        this.maxAgeOfDependents = maxAgeOfDependents;
        this.brokeragePercentage = brokeragePercentage;
        this.policyPlacedTypeLid = policyPlacedTypeLid;
        this.remarks = remarks ?? null;
        this.statusLid = statusLid ?? null;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.OpportunityPlacementSlipGeneration = OpportunityPlacementSlipGeneration;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_from_date", type: "date", nullable: false }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], OpportunityPlacementSlipGeneration.prototype, "policyFromDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_to_date", type: "date", nullable: false }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], OpportunityPlacementSlipGeneration.prototype, "policyToDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "sum_insured", type: "numeric", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "sumInsured", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "basic_premium", type: "numeric", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "basicPremium", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "is_premium_installment_based",
        type: "int",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "isPremiumInstallmentBased", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "fee", type: "numeric", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "fee", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "is_fee_in_installment", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "isFeeInInstallment", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "terrorism_commission_percentage",
        type: "numeric",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "terrorismCommissionPercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "service_tax_percentage", type: "numeric", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "serviceTaxPercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "service_tax_amount", type: "numeric", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "serviceTaxAmount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "other", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPlacementSlipGeneration.prototype, "other", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "total_premium", type: "numeric", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "totalPremium", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "lead_insurer_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "leadInsurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "is_lead_insurer_pay_commission",
        type: "int",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "isLeadInsurerPayCommission", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "placement_slip_date", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], OpportunityPlacementSlipGeneration.prototype, "placementSlipDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "max_age_of_dependents", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "maxAgeOfDependents", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "brokerage_percentage", type: "numeric", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_placed_type_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "policyPlacedTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPlacementSlipGeneration.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipGeneration.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], OpportunityPlacementSlipGeneration.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], OpportunityPlacementSlipGeneration.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPlacementSlipGeneration.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp, { onDelete: "SET NULL" }),
    (0, typeorm_1.JoinColumn)({ name: "status_lid" }),
    tslib_1.__metadata("design:type", typeof (_k = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _k : Object)
], OpportunityPlacementSlipGeneration.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_placement_slip_tpa_map_entity_1.OpportunityPlacementSlipTpaMap, (tpa) => tpa.placementSlip),
    tslib_1.__metadata("design:type", Array)
], OpportunityPlacementSlipGeneration.prototype, "tpaMaps", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_placement_slip_insurer_map_entity_1.OpportunityPlacementSlipInsurerMap, (insurer) => insurer.placementSlip),
    tslib_1.__metadata("design:type", Array)
], OpportunityPlacementSlipGeneration.prototype, "insurerMaps", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_placement_slip_installment_detail_entity_1.OpportunityPlacementSlipInstallementDetail, (installment) => installment.placementSlip),
    tslib_1.__metadata("design:type", Array)
], OpportunityPlacementSlipGeneration.prototype, "installmentDates", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_placement_slip_sharing_detail_entity_1.OpportunityPlacementSlipSharingDetail, (sharing) => sharing.placementSlip),
    tslib_1.__metadata("design:type", Array)
], OpportunityPlacementSlipGeneration.prototype, "sharingDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_placement_slip_cd_detail_entity_1.OpportunityPlacementSlipCDDetail, (cd) => cd.placementSlip),
    tslib_1.__metadata("design:type", Array)
], OpportunityPlacementSlipGeneration.prototype, "cdDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_placement_slip_cover_detail_entity_1.OpportunityPlacementSlipCoverDetail, (cover) => cover.placementSlip),
    tslib_1.__metadata("design:type", Array)
], OpportunityPlacementSlipGeneration.prototype, "coverDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => placement_slip_document_map_entity_1.OpportunityPlacementSlipDocumentMap, (documentMap) => documentMap.placementSlip, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], OpportunityPlacementSlipGeneration.prototype, "documents", void 0);
exports.OpportunityPlacementSlipGeneration = OpportunityPlacementSlipGeneration = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_placement_slip_generation"),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, Number, Number, Number, Number, Number, Number, Number, Number, Object, Number, Number, Number, typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object, Number, Number, String, Object, Object, Number, Number])
], OpportunityPlacementSlipGeneration);
